var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 144 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4025 25.1518C42.4025 33.3068 35.8491 43.1479 27.7691 43.1479C19.6891 43.1479 13.1357 33.3068 13.1357 25.1518C13.1357 16.9969 19.6891 10.3828 27.7691 10.3828C35.8491 10.3828 42.4025 16.9969 42.4025 25.1518Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.893 25.1518C130.893 33.3068 124.339 43.1479 116.259 43.1479C108.179 43.1479 101.626 33.3068 101.626 25.1518C101.626 16.9969 108.179 10.3828 116.259 10.3828C124.339 10.3828 130.893 16.9969 130.893 25.1518Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0984 19.2608C91.0984 29.9596 82.5575 42.7226 72.0145 42.7226C61.4716 42.7226 52.9307 29.9596 52.9307 19.2608C52.9307 8.56196 61.4716 0 72.0145 0C82.5575 0 91.0984 8.62011 91.0984 19.2608Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.237 74.6286C108.237 90.3425 98.4427 88.9615 72.0134 88.9615C45.584 88.9615 35.79 90.4152 35.79 74.6286C35.79 58.842 56.4582 46.1953 72.0134 46.1953C87.5685 46.1953 108.237 58.9292 108.237 74.6286Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5523 67.6088C55.3363 63.2624 53.5071 59.1631 50.4105 56.125C43.4394 60.9075 38.3408 67.6088 38.3408 74.7026C38.3408 76.0254 38.4128 77.3482 38.6001 78.6565C50.7849 78.453 55.5523 77.1738 55.5523 67.6088Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1267 74.6226C33.1267 66.5404 37.8508 58.6326 46.4206 52.44C40.9907 48.3553 34.4662 46.044 27.6968 45.7969C15.8432 45.7969 0 55.5508 0 67.6015C0 79.6522 6.58213 78.5765 27.7688 78.5765H33.3859C33.2275 77.2683 33.1411 75.9455 33.1267 74.6226Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6184 56.125C90.5074 59.2067 88.6926 63.3641 88.5342 67.7542C88.5342 77.4064 92.783 78.6274 105.386 78.7437C105.602 77.4354 105.702 76.0981 105.688 74.7753C105.63 67.5361 100.532 60.8348 93.6184 56.125Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26 45.7969C109.491 46.044 102.966 48.3553 97.5361 52.44C106.178 58.6616 110.83 66.5404 110.83 74.6226C110.83 75.9455 110.758 77.2683 110.585 78.5911H116.231C136.482 78.5911 144 79.6522 144 67.6161C144 55.5799 128.186 45.7969 116.26 45.7969Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4918",
    x: 0,
    y: 0,
    width: 144,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4918"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploye);
export default __webpack_public_path__ + "static/media/employe.9028dbdccb97ffdacc14403cfd13caf8.svg";
export { ForwardRef as ReactComponent };